<template>
  <div class="products-page">
    <!-- 页面标题区域 -->
    <section class="page-title">
      <div class="container">
        <h1>健康服务</h1>
        <p>专业医疗服务，呵护您的健康</p>
      </div>
    </section>

    <!-- 服务类别 -->
    <section class="service-categories">
      <div class="container">
        <div class="section-title">
          <h2>医疗服务</h2>
          <p>选择最适合您的健康方案</p>
        </div>
        <div class="category-grid">
          <div
            class="category-item"
            v-for="(category, index) in categories"
            :key="index">
            <div class="category-icon">
              <img :src="category.icon" :alt="category.title" />
            </div>
            <h3>{{ category.title }}</h3>
            <p>{{ category.description }}</p>
            <el-button class="more-btn">了解更多</el-button>
          </div>
        </div>
      </div>
    </section>

    <!-- 产品展示 -->
    <section class="products-showcase">
      <div class="container">
        <div class="section-title">
          <h2>健康套餐</h2>
          <p>个性化健康检查与管理方案</p>
        </div>
        <div class="products-grid">
          <div
            class="product-card"
            v-for="(product, index) in products"
            :key="index">
            <div class="product-img">
              <img :src="product.image" :alt="product.title" />
            </div>
            <div class="product-info">
              <h3>{{ product.title }}</h3>
              <p>{{ product.description }}</p>
              <div class="product-features">
                <span
                  v-for="(feature, idx) in product.features"
                  :key="idx"
                  class="feature-tag"
                  >{{ feature }}</span
                >
              </div>
              <div class="product-actions">
                <el-button type="primary">预约服务</el-button>
                <el-button>查看详情</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务保障 -->
    <section class="service-guarantee">
      <div class="container">
        <div class="section-title">
          <h2>医疗保障</h2>
          <p>专业团队，贴心服务</p>
        </div>
        <div class="guarantee-list">
          <div
            class="guarantee-item"
            v-for="(item, index) in guarantees"
            :key="index">
            <div class="guarantee-number">{{ index + 1 }}</div>
            <div class="guarantee-content">
              <h3>{{ item.title }}</h3>
              <p>{{ item.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 客户反馈 -->
    <section class="customer-feedback">
      <div class="container">
        <div class="section-title">
          <h2>患者评价</h2>
          <p>来自真实患者的反馈</p>
        </div>
        <div class="feedback-slider">
          <div
            class="feedback-item"
            v-for="(feedback, index) in feedbacks"
            :key="index">
            <div class="feedback-content">
              <p>{{ feedback.content }}</p>
            </div>
            <div class="feedback-author">
              <img :src="feedback.avatar" :alt="feedback.name" />
              <div class="author-info">
                <h4>{{ feedback.name }}</h4>
                <p>{{ feedback.company }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Products",
  components: {},
  data() {
    return {
      // 服务类别数据
      categories: [
        {
          title: "健康体检",
          description:
            "全面的健康检查服务，及早发现健康隐患，制定个性化健康管理方案。",
          icon: "https://picsum.photos/id/237/100/100",
        },
        {
          title: "专科诊疗",
          description:
            "内科、外科、妇科、儿科等多科室专业诊疗服务，提供精准诊断和治疗方案。",
          icon: "https://picsum.photos/id/401/100/100",
        },
        {
          title: "慢病管理",
          description:
            "针对高血压、糖尿病等慢性病患者提供专业管理和干预，改善生活质量。",
          icon: "https://picsum.photos/id/433/100/100",
        },
        {
          title: "远程医疗",
          description:
            "在线问诊、健康咨询、复诊服务，随时随地获取专业医疗建议。",
          icon: "https://picsum.photos/id/366/100/100",
        },
      ],
      // 产品数据
      products: [
        {
          title: "精英体检套餐",
          description:
            "全面的健康体检方案，包含多项先进检查项目，适合高端商务人士及注重健康管理的人群。",
          image: "https://picsum.photos/id/96/600/400",
          features: [
            "全身CT扫描",
            "肿瘤标志物筛查",
            "心脏功能评估",
            "专家解读",
          ],
        },
        {
          title: "中年健康管理套餐",
          description:
            "专为35-55岁人群设计的健康管理方案，重点关注心脑血管、代谢系统等中年常见健康问题。",
          image: "https://picsum.photos/id/1011/600/400",
          features: [
            "心血管健康评估",
            "糖尿病风险筛查",
            "骨密度检测",
            "健康生活指导",
          ],
        },
        {
          title: "女性健康关爱套餐",
          description:
            "全面的女性健康检查方案，包含妇科专项检查，呵护女性健康。",
          image: "https://picsum.photos/id/655/600/400",
          features: [
            "妇科专项检查",
            "乳腺检查",
            "激素水平检测",
            "妇科专家咨询",
          ],
        },
        {
          title: "老年健康养护套餐",
          description:
            "专为60岁以上老年人设计的健康检查方案，关注老年常见疾病筛查和健康养护。",
          image: "https://picsum.photos/id/1027/600/400",
          features: ["老年综合评估", "认知功能检测", "慢性病管理", "营养指导"],
        },
      ],
      // 服务保障数据
      guarantees: [
        {
          title: "专业医疗团队",
          description:
            "由资深医师和医护人员组成的专业团队，拥有丰富的临床经验和专业技能。",
        },
        {
          title: "先进医疗设备",
          description:
            "引进国际领先的医疗检查设备，确保诊断结果的准确性和可靠性。",
        },
        {
          title: "个性化健康方案",
          description:
            "根据个人体检结果和健康需求，制定个性化的健康管理和干预方案。",
        },
        {
          title: "隐私保护承诺",
          description: "严格保护患者隐私，所有健康数据严格保密，确保信息安全。",
        },
      ],
      // 患者反馈数据
      feedbacks: [
        {
          content:
            "康泰医疗的体检服务非常专业，环境舒适，医护人员态度亲切，报告解读详细，让我对自己的健康状况有了全面了解。",
          name: "张先生",
          company: "企业高管",
          avatar: "https://picsum.photos/id/1012/100/100",
        },
        {
          content:
            "作为一名糖尿病患者，康泰医疗的慢病管理服务帮助我有效控制了血糖，医生的专业指导和定期随访让我非常安心。",
          name: "李女士",
          company: "退休教师",
          avatar: "https://picsum.photos/id/1005/100/100",
        },
        {
          content:
            "远程医疗服务非常便捷，足不出户就能咨询专业医生，特别是对于行动不便的老年人来说非常实用。",
          name: "王大爷",
          company: "退休干部",
          avatar: "https://picsum.photos/id/1062/100/100",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {},
};
</script>

<style scoped lang="less">
.container {
  width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 页面标题样式 */
.page-title {
  background: linear-gradient(135deg, #52c41a 0%, #389e0d 100%);
  color: #fff;
  padding: 100px 0;
  text-align: center;

  h1 {
    font-size: 48px;
    margin-bottom: 20px;
    font-weight: 600;
  }

  p {
    font-size: 20px;
    opacity: 0.9;
  }
}

/* 通用区块标题 */
.section-title {
  text-align: center;
  margin-bottom: 60px;

  h2 {
    font-size: 36px;
    color: #333;
    margin-bottom: 15px;
    position: relative;
    display: inline-block;

    &::after {
      content: "";
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      width: 80px;
      height: 3px;
      background: #52c41a;
    }
  }

  p {
    font-size: 18px;
    color: #666;
  }
}

/* 服务类别样式 */
.service-categories {
  padding: 100px 0;

  .category-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
  }

  .category-item {
    background: #fff;
    padding: 40px 30px;
    border-radius: 12px;
    text-align: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    }

    .category-icon {
      width: 100px;
      height: 100px;
      margin: 0 auto 25px;
      border-radius: 50%;
      overflow: hidden;
      background: #f0f7ff;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 60%;
        height: 60%;
        object-fit: contain;
      }
    }

    h3 {
      font-size: 20px;
      color: #333;
      margin-bottom: 15px;
      font-weight: 600;
    }

    p {
      font-size: 14px;
      color: #666;
      line-height: 1.6;
      margin-bottom: 20px;
    }

    .more-btn {
      color: #52c41a;
      border-color: #52c41a;

      &:hover {
        color: #fff;
        background: #52c41a;
      }
    }
  }
}

/* 产品展示样式 */
.products-showcase {
  padding: 100px 0;
  background: #fafafa;

  .products-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;
  }

  .product-card {
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    height: 100%;

    .product-img {
      height: 280px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.5s ease;

        &:hover {
          transform: scale(1.05);
        }
      }
    }

    .product-info {
      padding: 30px;
      flex: 1;
      display: flex;
      flex-direction: column;
    }

    h3 {
      font-size: 24px;
      color: #333;
      margin-bottom: 15px;
      font-weight: 600;
    }

    p {
      font-size: 16px;
      color: #666;
      line-height: 1.6;
      margin-bottom: 20px;
    }

    .product-features {
      margin-bottom: 25px;

      .feature-tag {
        display: inline-block;
        background: #f6ffed;
        color: #52c41a;
        padding: 5px 12px;
        border-radius: 20px;
        font-size: 12px;
        margin-right: 10px;
        margin-bottom: 10px;
      }
    }

    .product-actions {
      margin-top: auto;
      display: flex;
      gap: 15px;

      button {
        flex: 1;
      }
    }
  }
}

/* 服务保障样式 */
.service-guarantee {
  padding: 100px 0;

  .guarantee-list {
    display: flex;
    flex-direction: column;
    gap: 30px;
  }

  .guarantee-item {
    display: flex;
    align-items: flex-start;
    gap: 30px;
    padding: 30px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;

    &:hover {
      transform: translateX(10px);
      box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
    }

    .guarantee-number {
      width: 60px;
      height: 60px;
      background: #52c41a;
      color: #fff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 28px;
      font-weight: 600;
      flex-shrink: 0;
    }

    .guarantee-content {
      flex: 1;

      h3 {
        font-size: 22px;
        color: #333;
        margin-bottom: 10px;
        font-weight: 600;
      }

      p {
        font-size: 16px;
        color: #666;
        line-height: 1.6;
      }
    }
  }
}

/* 客户反馈样式 */
.customer-feedback {
  padding: 100px 0;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);

  .feedback-slider {
    display: flex;
    gap: 30px;
    overflow-x: auto;
    padding-bottom: 20px;

    &::-webkit-scrollbar {
      height: 8px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #52c41a;
      border-radius: 4px;
    }
  }

  .feedback-item {
    background: #fff;
    border-radius: 12px;
    padding: 40px;
    flex: 0 0 400px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);

    .feedback-content {
      margin-bottom: 30px;

      p {
        font-size: 16px;
        color: #666;
        line-height: 1.8;
        font-style: italic;
        position: relative;
        padding-left: 20px;

        &::before {
          content: '"';
          position: absolute;
          left: 0;
          top: 0;
          font-size: 32px;
          color: #52c41a;
          opacity: 0.3;
        }
      }
    }

    .feedback-author {
      display: flex;
      align-items: center;
      gap: 20px;

      img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        object-fit: cover;
      }

      .author-info {
        h4 {
          font-size: 18px;
          color: #333;
          margin-bottom: 5px;
          font-weight: 600;
        }

        p {
          font-size: 14px;
          color: #999;
        }
      }
    }
  }
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .container {
    width: 100%;
    padding: 0 30px;
  }

  .service-categories {
    .category-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  .products-showcase {
    .products-grid {
      grid-template-columns: 1fr;
    }
  }
}

@media (max-width: 768px) {
  .page-title {
    padding: 80px 0;

    h1 {
      font-size: 36px;
    }

    p {
      font-size: 18px;
    }
  }

  .section-title {
    h2 {
      font-size: 28px;
    }

    p {
      font-size: 16px;
    }
  }

  .service-categories {
    padding: 80px 0;

    .category-grid {
      grid-template-columns: 1fr;
      gap: 20px;
    }
  }

  .products-showcase {
    padding: 80px 0;

    .product-card {
      .product-img {
        height: 220px;
      }
    }
  }

  .service-guarantee {
    padding: 80px 0;

    .guarantee-item {
      flex-direction: column;
      text-align: center;

      .guarantee-number {
        margin: 0 auto 20px;
      }
    }
  }

  .customer-feedback {
    padding: 80px 0;

    .feedback-slider {
      .feedback-item {
        flex: 0 0 calc(100vw - 60px);
      }
    }
  }
}
</style>
